import { Action } from '@ngrx/store'
import * as GisSettingsTypes from './gis-settings.types'

export class FetchGisSettingsRequest implements Action {
  readonly type = GisSettingsTypes.FETCH_GIS_SETTINGS_REQUEST
  constructor() {}
}

export class FetchGisSettingsSuccess implements Action {
  readonly type = GisSettingsTypes.FETCH_GIS_SETTINGS_SUCCESS
  constructor(public payload: any) {}
}

export class FetchGisSettingsFailure implements Action {
  readonly type = GisSettingsTypes.FETCH_GIS_SETTINGS_FAILURE
  constructor(public payload: any) {}
}

export class UpdateGisSettingsRequest implements Action {
  readonly type = GisSettingsTypes.UPDATE_GIS_SETTINGS_REQUEST
  constructor(public payload: any) {}
}

export class UpdateGisSettingsSuccess implements Action {
  readonly type = GisSettingsTypes.UPDATE_GIS_SETTINGS_SUCCESS
  constructor() {}
}

export class UpdateGisSettingsFailure implements Action {
  readonly type = GisSettingsTypes.UPDATE_GIS_SETTINGS_FAILURE
  constructor(public payload: any) {}
}

export class UpdateField implements Action {
  readonly type = GisSettingsTypes.UPDATE_FIELD
  public constructor(
    public field: string,
    public value: any,
    public path: string,
  ) {}
}

export class SetDefaultData implements Action {
  readonly type = GisSettingsTypes.SET_DEFAULT_DATA
  public constructor(public path: string) {}
}

export type Actions =
  | FetchGisSettingsSuccess
  | FetchGisSettingsFailure
  | FetchGisSettingsRequest
  | UpdateGisSettingsRequest
  | UpdateGisSettingsSuccess
  | UpdateGisSettingsFailure
  | SetDefaultData
  | UpdateField
